import { render, staticRenderFns } from "./miyou_ios.vue?vue&type=template&id=adc9dfec&scoped=true&"
import script from "./miyou_ios.vue?vue&type=script&lang=js&"
export * from "./miyou_ios.vue?vue&type=script&lang=js&"
import style0 from "./miyou_ios.vue?vue&type=style&index=0&id=adc9dfec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adc9dfec",
  null
  
)

export default component.exports